// extracted by mini-css-extract-plugin
export default {"bookCard":"styles_bookCard__bimQG"};